import React, {useRef, RefObject, useState} from "react"
import {connect, useDispatch} from "react-redux"
import {UseModel} from "../../../function/hooks/useDataFromRedux"
import {promiseType, VIEWTYPE} from "../../util/utilData"
import Icons from "../../../static/Icon/style.less"
import Styles from "./uploadFile.less"
import request from "../../../../entrance/request"
import ShowAttachment from "../../../function/hooks/showAttachment"
import ShowReUpLoad from "../../../function/hooks/showReUpLoad"
import uploadLocalFile from "../../../static/pic/localUpload.svg"
import uploadAttachmentFile from "../../../static/pic/attachmentUpload.svg"
import pdfSvg from "../../../static/pic/pdfSvg.svg"
import wordSvg from "../../../static/pic/wordSVG.svg"
import {v4} from "uuid"
import picSvg from "../../../static/pic/picSvg.svg"
import ofdSvg from "../../../static/pic/ofdSvg.svg"
import {isValidKey, UploadTips} from "../tips/uploadTips"
import uploadLocalFileHover from "../../../static/pic/localUploadHover.svg"
import uploadAttachmentFileHover from "../../../static/pic/attachmentUploadHover.svg"
import {Model, ReducerState} from "../../../reducer/interface/baseInterface"
import {FileInfo} from "../../../reducer/interface/fileInterface"
import {GlobalState} from "../../../reducer/interface/globalInterface"
import {ComparisonStatus} from "../../../reducer/interface/controlInterface"
import classnames from "classnames/bind"
import classNames from "classnames"
const cx = classnames.bind(Styles)

interface UploadFileProps {
    type: "Base" | "Compare"
    fileInfo: FileInfo
    global: GlobalState
    loading: boolean
    comparisonStatus: ComparisonStatus
    activeView: string
}

export const getVaildFileType = (type: string) => {
    if (type === "Base") {
        return "b"
    }
    if (type === "Compare") {
        return "c"
    }
    return ""
}

const UploadFile: React.FunctionComponent<UploadFileProps> = (props) => {
    const inputFile = useRef<HTMLInputElement>(null)
    const dispatch = useDispatch()
    const model = UseModel()
    const changeFiles = () => {
        if (inputFile.current) {
            const file = inputFile.current.files && inputFile.current.files.length > 0 && inputFile.current.files[0]
            const type = inputFile.current.value.slice(inputFile.current.value.lastIndexOf(".") + 1).toLowerCase()
            if (isValidKey(type, promiseType) && promiseType[type] === true) {
                if (file && file.size > 10 * 1024 * 1024) {
                    dispatch({type: "outputMsg", payload: "文件大小不符合要求。"})
                    return
                } else {
                    if (inputFile.current.files) {
                        dispatch({
                            type: `replaceNew${props.type}`,
                            payload: {
                                name: inputFile.current.files[0].name,
                                type: type,
                                hasData: true,
                                url: "",
                                status: "waiting",
                            },
                        })
                        toUrl(inputFile.current.files[0], type)
                        // toBase(inputFile.current.files[0], type)
                    }
                }
            } else if (type !== undefined && type !== "") {
                inputFile.current.value = ""
                dispatch({type: "outputMsg", payload: "暂不支持该文件类型，请重新上传。"})
            }
        }
    }

    const toBase = (file: File, type: string) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
            setTimeout(() => {
                dispatch({
                    type: `replaceNew${props.type}`,
                    payload: {
                        name: file.name,
                        type: type,
                        hasData: true,
                        url: reader.result,
                        status: "success",
                    },
                })
            }, 2000)
        }
    }

    const toUrl = async (file: File, type: string) => {
        const form = new FormData()
        form.append("file", file)
        form.append("url", file.name)
        form.append("urlType", "pc")
        form.append("appId", "cvp")
        form.append("fId", "cvp_tda_plan")
        form.append("token", v4())
        await request(
            `${props.global.serverUrl}`,
            {
                method: "POST",
                body: form,
            },
            (res: any) => {
                if (res.status === "success") {
                    model.invokeAsync(`valid${props.type}File`, {
                        fileName: file.name,
                        url: res.url,
                        type: getVaildFileType(props.type),
                    })
                    dispatch({
                        type: `replaceNew${props.type}`,
                        payload: {
                            name: file.name,
                            type: type,
                            hasData: true,
                            url: res.url,
                            status: "waiting",
                        },
                    })
                    // dispatch({
                    //     type: `replaceNew${props.type}`,
                    //     payload: {
                    //         name: file.name,
                    //         type: type,
                    //         hasData: true,
                    //         url: res.url,
                    //         status: "success",
                    //     },
                    // })
                } else {
                    dispatch({type: "outputMsg", payload: res.description})
                    dispatch({
                        type: `replaceNew${props.type}`,
                        payload: {
                            name: file.name,
                            type: type,
                            hasData: false,
                            url: res.url,
                            status: "error",
                        },
                    })
                }
            }
        )
    }

    return (
        <div className={Styles.uploadFileBox}>
            <div className={Styles.uploadFileInnerBox}>
                <input
                    className={Styles.fileInput}
                    // accept={".docx,.doc,.png,.jpg,.jepg,.pdf"}
                    accept={".docx,.doc,.png,.ofd,.jpg,.jpeg,.pdf,.bmp,.tiff,.tif"}
                    // accept={".png,.jpg,.jpeg,.pdf,.bmp,.tiff,.tif"}
                    onChange={() => changeFiles()}
                    ref={inputFile}
                    type={"file"}
                />
                <div className={Styles.header}>{props.type === "Base" ? "原文档" : "比对文档"}</div>
                <div className={Styles.body}>
                    <div
                        style={{display: props.activeView === "display" && props.loading === true ? "block" : "none"}}
                        className={Styles.uploadMark}
                    >
                        <div className={Styles.uploadSlider} />
                    </div>
                    <div className={Styles.uploadFilePath}>
                        <UploadFileCommponent
                            type={props.type}
                            model={model}
                            inputRef={inputFile}
                            onChange={changeFiles}
                            billid={props.global.billid}
                            viewType={props.global.viewType}
                            fileInfo={props.fileInfo}
                        />
                    </div>
                </div>
                <div className={Styles.footer}>
                    <span>不超过10M、500页，支持pdf、doc、docx 、jpg、jpeg、bmp、png、ofd格式。</span>
                </div>
            </div>
        </div>
    )
}

interface UploadFileCommponentProps {
    type: "Base" | "Compare"
    model: Model
    inputRef: RefObject<HTMLInputElement>
    onChange: () => void
    billid: string | number
    viewType: string
    fileInfo: FileInfo
}

const UploadFileCommponent: React.FunctionComponent<UploadFileCommponentProps> = (props) => {
    const showAttachment = ShowAttachment()
    const showReUpload = ShowReUpLoad()
    const [showUpload, setShowUpload] = useState(false)
    const [localImg, setLocalImg] = useState(uploadLocalFile)
    const [dragOver, setDragOver] = useState(false)
    const [attachmentImg, setAttachmentImg] = useState(uploadAttachmentFile)
    const fileInfo = props.fileInfo
    const toFalseFunc = props.type === "Base" ? showReUpload.toBaseFalse : showReUpload.toCompareFalse
    const toTrueFunc = props.type === "Base" ? showReUpload.toBaseTrue : showReUpload.toCompareTrue
    const classnames = cx({uploadFileCommponent: true, dragoverStyle: dragOver})
    const hasDataCommponent = () => {
        const type = fileInfo.type
        const name = fileInfo.name
        const getTextAndStyle = () => {
            switch (fileInfo.status) {
                case "success":
                    return {
                        text: "重新上传",
                        style: {
                            color: "#999999",
                            cursor: "pointer",
                        },
                    }
                case "waiting":
                    return {
                        text: "上传中",
                        style: {
                            color: "#999999",
                        },
                    }
                case "error":
                    return {
                        text: "上传失败",
                        style: {
                            color: "red",
                        },
                    }
                default:
                    return {
                        text: "",
                        style: {},
                    }
            }
        }
        const {text, style} = getTextAndStyle()
        const getPic = () => {
            switch (type) {
                case "pdf":
                    return pdfSvg
                case "doc":
                    return wordSvg
                case "docx":
                    return wordSvg
                case "png":
                    return picSvg
                case "jpg":
                    return picSvg
                case "jpeg":
                    return picSvg
                case "tif":
                    return picSvg
                case "tiff":
                    return picSvg
                case "bmp":
                    return picSvg
                case "ofd":
                    return ofdSvg
                default:
                    return picSvg
            }
        }
        let tipsTime: any = null
        const btnList = () => {
            let resultBtnList = [
                <button
                    onClick={() => {
                        props.inputRef.current?.click()
                        toFalseFunc()
                    }}
                    className={Styles.reuploadBtn}
                    key={"reUpload1"}
                >
                    本地文件
                </button>,
            ]
            if (props.viewType === VIEWTYPE.CREATE) {
                resultBtnList.push(
                    <button
                        onClick={() => {
                            props.model.invokeAsync("getAttachmentList", props.billid)
                            showAttachment.toTrue(props.type)
                            toFalseFunc()
                        }}
                        className={Styles.reuploadBtn}
                        key={"reUpload2"}
                    >
                        单据附件
                    </button>
                )
            }
            return resultBtnList
        }
        return (
            <div className={Styles.hasDataCommponent}>
                <div className={Styles.hasDataBody}>
                    <div className={Styles.fileInfo}>
                        <div className={Styles.fileType}>
                            <img src={getPic()} />
                        </div>
                        <span title={name} className={Styles.fileName}>
                            {name}
                        </span>
                    </div>
                </div>
                <div className={Styles.hasDataFooter}>
                    {fileInfo.status === "success" || fileInfo.status === "error" ? (
                        <span
                            onMouseEnter={() => {
                                clearTimeout(tipsTime)
                                toTrueFunc()
                            }}
                            onMouseOver={() => {
                                clearTimeout(tipsTime)
                                toTrueFunc()
                            }}
                            onMouseMove={() => {
                                clearTimeout(tipsTime)
                                toTrueFunc()
                            }}
                            onMouseLeave={() => {
                                clearTimeout(tipsTime)
                                tipsTime = setTimeout(() => {
                                    toFalseFunc()
                                }, 1000)
                            }}
                            style={style}
                            className={Styles.reUpload}
                        >
                            <UploadTips viewType={props.viewType} type={props.type} text={btnList()} />
                            <span
                                onClick={() => {
                                    if (props.viewType === VIEWTYPE.TEST) {
                                        props.inputRef.current?.click()
                                    }
                                }}
                            >
                                {text}
                            </span>
                        </span>
                    ) : (
                        <React.Fragment>
                            <span
                                className={classNames(
                                    {[Styles.rotateIcon]: fileInfo.status === "waiting"},
                                    {[Icons["icon-loading"]]: fileInfo.status === "waiting"},
                                    {
                                        [Icons["icon-size"]]: fileInfo.status === "waiting",
                                    }
                                )}
                            />
                            <span style={style} className={Styles.reUpload}>
                                {text}
                            </span>
                        </React.Fragment>
                    )}
                </div>
            </div>
        )
    }
    const productCommponent = () => {
        // onClick={() => props.inputRef.current.click()}
        return (
            <div className={Styles.noDataCommponent}>
                <div
                    onMouseEnter={() => setShowUpload(true)}
                    onMouseLeave={() => setShowUpload(false)}
                    className={Styles.noDataUpload}
                >
                    <div
                        style={{display: showUpload ? "flex" : "none"}}
                        onClick={() => props.inputRef.current?.click()}
                        onMouseEnter={() => {
                            setLocalImg(uploadLocalFileHover)
                        }}
                        onMouseLeave={() => {
                            setLocalImg(uploadLocalFile)
                        }}
                        className={Styles.uploadLocalFile}
                    >
                        <img alt={""} src={localImg} />
                        <span>本地文件</span>
                    </div>
                    <div
                        style={{display: showUpload ? "flex" : "none"}}
                        onClick={() => {
                            props.model.invokeAsync("getAttachmentList", props.billid)
                            showAttachment.toTrue(props.type)
                        }}
                        onMouseEnter={() => {
                            setAttachmentImg(uploadAttachmentFileHover)
                        }}
                        onMouseLeave={() => {
                            setAttachmentImg(uploadAttachmentFile)
                        }}
                        className={Styles.uploadAttachmentFile}
                    >
                        <img alt={""} src={attachmentImg} />
                        <span>单据附件</span>
                    </div>
                    <div style={{display: showUpload ? "none" : "flex"}} className={Styles.noDataUpload}>
                        <span className={Styles.noDataUploadTip}>+</span>
                        <span>点击或拖拽上传</span>
                    </div>
                </div>
            </div>
        )
    }
    const testCommponent = () => {
        return (
            <div onClick={() => props.inputRef.current?.click()} className={Styles.noDataCommponent}>
                <div className={Styles.noDataUpload}>
                    <span className={Styles.noDataUploadTip}>+</span>
                    <span>点击或拖拽上传</span>
                </div>
            </div>
        )
    }
    const viewTypeCommponent = () => {
        switch (props.viewType) {
            case VIEWTYPE.HISTORY:
                return productCommponent()
            case VIEWTYPE.CREATE:
                return productCommponent()
            case VIEWTYPE.TEST:
                return testCommponent()
            case VIEWTYPE.SHOW:
                return testCommponent()
            default:
                return testCommponent()
        }
    }
    return (
        <div
            onDragEnter={(e) => {
                setDragOver(true)
                e.preventDefault()
            }}
            onDragOver={(e) => {
                setDragOver(true)
                e.preventDefault()
            }}
            onDragLeave={(e) => {
                setDragOver(false)
                e.preventDefault()
            }}
            onDrop={(e) => {
                setDragOver(false)
                e.preventDefault()
                if (props.inputRef.current) {
                    props.inputRef.current.files = e.dataTransfer.files
                    props.onChange()
                }
            }}
            className={classnames}
        >
            {fileInfo.hasData ? hasDataCommponent() : viewTypeCommponent()}
        </div>
    )
}

export default connect((state: ReducerState) => {
    return {
        global: state.global,
        loading: state.control.loading,
        comparisonStatus: state.control.comparisonStatus,
        activeView: state.control.activeView,
    }
})(UploadFile)
